import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { EyeFill } from 'react-bootstrap-icons';
import { GMapSelector } from './GMapSelector';
import { Predio } from '../../../service/types/types';

interface ViewPredioModalProps {
  predio: Predio;
}

export default function ViewPredioModal({ predio }: ViewPredioModalProps) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button size="sm" variant="outline-secondary" onClick={() => setShow(true)}>
        <EyeFill className="me-1" /> Ver
      </Button>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{predio.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GMapSelector initialCenter={predio.location.coordinates} onSelect={() => {}} isReadOnly />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShow(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
